import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useParams } from "@tanstack/react-router";

export const useCarePlanPreview = ({
  carePlanId = "",
}: { carePlanId?: string }) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });

  return useApi<string>({
    queryOptions: {
      enabled: Boolean(carePlanId),
      queryFn: async () => {
        const response = await axiosInstance.get<string>(
          `/amazon-clinic/care-plans/${carePlanId}/preview`,
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.PREVIEW({
        patientId,
        carePlanId,
      }),
    },
  });
};
